import { Component } from '@angular/core';

@Component({
    selector: 'app-academy',
    templateUrl: './academy.component.html',
    styleUrls: ['./academy.component.scss'],
    standalone: false
})
export class AcademyComponent {}
